<template>
    <rkm-modal
        ref="Modal"
        title="Opções de impressão"
        persistent
        @close="reset"
        @cancel="reset"
        @hide="reset"
    >
        <template v-if="form.recepcao.length > 0">
            <h6>Recepção</h6>

            <rkm-form-checkbox
                v-if="form.recepcao.length > 1"
                v-model="model.selectAllRecepcao"
                :disabled="disabledSelectAllRecepcao"
            >
                Todos
            </rkm-form-checkbox>

           <rkm-form-checkbox-group
                :options="form.recepcao"
                v-model="model.recepcao"
                stacked
            />
        </template>

        <template v-if="form.triagem.length > 0">
            <h6>Triagem</h6>

            <rkm-form-checkbox
                v-if="form.triagem.length > 1"
                v-model="model.selectAllTriagem"
                :disabled="disabledSelectAllTriagem"
            >
                Todos
            </rkm-form-checkbox>

            <rkm-form-checkbox-group
                :options="form.triagem"
                v-model="model.triagem"
                stacked
            />
        </template>

        <template v-if="form.medicoEnfermagem.length > 0">
            <h6>Atendimento médico / Enfermagem</h6>

            <rkm-form-checkbox
                v-if="form.medicoEnfermagem.length > 1"
                v-model="model.selectAllMedicoEnfermagem"
                :disabled="disabledSelectAllMedicoEnfermagem"
            >
                Todos
            </rkm-form-checkbox>

            <rkm-form-checkbox-group
                :options="form.medicoEnfermagem"
                v-model="model.medicoEnfermagem"
                stacked
            />
        </template>

        <template v-if="impressoesFaa.length > 0">
            <h6>FAA</h6>

            <rkm-form-checkbox-group
                :options="impressoesFaa"
                v-model="model.faa"
                stacked
            />
        </template>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                color="primary"
                :disabled="!anyItemChecked"
                @click="print"
            >
                Imprimir
            </rkm-button>
        </template>

        <ModalUsuarioFaturamentoExameLaboratorial
            :usuarios="additionals.usuariosFaturamentoExameLaboratorial"
            @cancel="uncheckFaaEletronica"
            @save="saveLotacaoFaturamentoExameLaboratorial"
            ref="ModalUsuarioFaturamentoExameLaboratorial"
        />

        <ModalImpressaoObservacao
            :atendimentos="atendimentosObservacao"
            @cancel="uncheckFaaEletronicaObservacao"
            @save="saveFaaEletronicaObservacao"
            ref="ModalImpressaoObservacao"
        />

        <ModalImpressaoPrescricaoInterna
            :atendimentos="atendimentosPrescricao"
            @cancel="uncheckPrescricaoInterna"
            @save="savePrescricaoInterna"
            ref="ModalImpressaoPrescricaoInterna"
        />
    </rkm-modal>
</template>

<script>
import ModalUsuarioFaturamentoExameLaboratorial from './components/usuario-faturamento-exame-laboratorial/Modal'
import ModalImpressaoObservacao from './components/impressao-observacao/Modal'
import ModalImpressaoPrescricaoInterna from './components/impressao-prescricao-interna/Modal'

// Others
import { mapActions, mapGetters } from 'vuex'
import { repository, error } from '@/mixins'

// Utils.
import etiqueta from '@/utils/pronto-atendimento/impressao/etiqueta'
import senha from '@/utils/painel-senha/impressao/senha'

export default {
    components: {
        ModalUsuarioFaturamentoExameLaboratorial,
        ModalImpressaoObservacao,
        ModalImpressaoPrescricaoInterna
    },
    computed: {
        ...mapGetters({
            centroCusto: 'getCentroCusto',
            cliente: 'getCliente',
            lotacao: 'getLotacao',
        }),
        anyItemChecked() {

            return this.model.recepcao.length > 0
                || this.model.triagem.length > 0
                || this.model.medicoEnfermagem.length > 0
                || this.model.faa.length > 0
        },
        disabledSelectAllRecepcao() {

            return !this.form.recepcao.find(i => !i.disabled)
        },
        disabledSelectAllTriagem() {

            return !this.form.triagem.find(i => !i.disabled)
        },
        disabledSelectAllMedicoEnfermagem() {

            return !this.form.medicoEnfermagem.find(i => !i.disabled)
        },
        impressoesFaa() {

            let impressoes = this.form.faa

            if (!this.fromObservacao) {

                impressoes = impressoes.filter(i => i.value !== 'eletronicaObservacao')
            }

            return impressoes
        },
        atendimentosObservacao() {

            const impressao = this.form.faa.find(i => i.value === 'eletronicaObservacao')

            return impressao ? impressao.data.atendimentos : []
        },
        atendimentosPrescricao(){

            const impressao = this.form.medicoEnfermagem.find(i => i.value === 'prescricaoInterna')

            return impressao ? impressao.data.atendimentos : []
        }
    },
    created() {

        this.repositories = {
            funcionalidadeImpressao: this.getConectaSusRepository('prontoAtendimento.impressao'),
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento'),
        }
    },
    data: () => ({
        atendimentoId: null,
        additionals: {
            faturarEnfermagem: false,
            usuariosFaturamentoExameLaboratorial: [],
            hasExamesLaboratoriaisPendente: false,
        },
        form: {
            recepcao: [],
            triagem: [],
            medicoEnfermagem: [],
            faa: [],
        },
        model: {
            selectAllTriagem: false,
            selectAllMedicoEnfermagem: false,
            recepcao: [],
            triagem: [],
            medicoEnfermagem: [],
            faa: [],
            lotacaoFaturamentoExameLaboratorialId: null,
            atendimentosFaaEletronicaObservacao: [],
            atendimentosPrescricaoInterna: [],
        },
        utils: { etiqueta, senha },
        callbackOnClose: null
    }),
    mixins: [repository, error],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(impressoes, atendimentoId, callbackOnClose = null) {
            if (impressoes.additionals) {

                this.additionals = impressoes.additionals
            }

            this.form.recepcao = impressoes.recepcao || []
            this.form.triagem = impressoes.triagem || []
            this.form.medicoEnfermagem = impressoes.medicoEnfermagem || []
            this.form.faa = impressoes.faa || []

            this.atendimentoId = atendimentoId
            this.callbackOnClose = callbackOnClose

            this.$refs.Modal.show()
        },
        uncheckFaaEletronica() {

            this.model.faa.splice(this.model.faa.findIndex(f => f === 'eletronica'), 1)
        },
        uncheckFaaEletronicaObservacao() {

            this.model.faa.splice(this.model.faa.findIndex(f => f === 'eletronicaObservacao'), 1)
        },
        uncheckPrescricaoInterna() {

            this.model.medicoEnfermagem.splice(this.model.medicoEnfermagem.findIndex(f => f === 'prescricaoInterna'), 1)
        },
        saveLotacaoFaturamentoExameLaboratorial(lotacaoId) {

            this.model.lotacaoFaturamentoExameLaboratorialId = lotacaoId
        },
        saveFaaEletronicaObservacao(atendimentos) {

            this.model.atendimentosFaaEletronicaObservacao = atendimentos
        },
        savePrescricaoInterna(atendimentos) {

            this.model.atendimentosPrescricaoInterna = atendimentos
        },
        print() {

            this.setLoading()

            this.executeActionsBeforePrint()
                .then(() => {

                    this.model.recepcao.forEach(i => this.downloadRecepcao(i))
                    this.model.triagem.forEach(i => this.downloadTriagem(i))
                    this.model.medicoEnfermagem.forEach(i => this.downloadMedicoEnfermagem(i))
                    this.model.faa.forEach(i => this.downloadFaa(i))
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        async executeActionsBeforePrint() {

            if (this.additionals.faturarEnfermagem) {

                if (this.additionals.usuariosFaturamentoExameLaboratorial.length === 1
                    && this.additionals.usuariosFaturamentoExameLaboratorial[0].lotacoes.length === 1
                ) {

                    this.model.lotacaoFaturamentoExameLaboratorialId = this.additionals
                        .usuariosFaturamentoExameLaboratorial[0].lotacoes[0].id
                }

                const { data } = await this.repositories.funcionalidadeImpressao.faturarEnfermagem({
                    atendimento_id : this.atendimentoId,
                    lotacao_id: this.model.lotacaoFaturamentoExameLaboratorialId,
                    plantao_id: this.plantaoId,
                })

                this.additionals.hasExamesLaboratoriaisPendente = false

                this.showMensagemFaturamentoAutomatico(data)
            }
        },
        showMensagemFaturamentoAutomatico(procedimentos) {

            let mensagem = ''

            const getList = (title, procedimentos) =>
                `<ul>
                    <li>
                        ${title}
                        <ul>
                            <li>
                                ${procedimentos.map(p => `Procedimento ${p.procedimento} faturado automaticamente
                                    para o profissional ${p.profissional}.`).join('</li><li>')}
                            </li>
                        </ul>
                    </li>
                </ul>`

            if (procedimentos.exameLaboratorial.length > 0) {

                mensagem += getList(
                    'Há exame laboratorial solicitado pelo médico',
                    procedimentos.exameLaboratorial
                )
            }

            if (procedimentos.prescricaoInterna.length > 0) {

                mensagem += getList(
                    'Há prescrição interna solicitada pelo médico',
                    procedimentos.prescricaoInterna
                )
            }

            if (procedimentos.exameImagem.length > 0) {

                mensagem += getList(
                    'Há exame de imagem solicitado pelo médico',
                    procedimentos.exameImagem
                )
            }

            if (mensagem !== '') {

                this.showAlert(mensagem, 'Procedimentos faturados', true)
            }
        },
        downloadRecepcao(item) {

            const items = {
                termoCiencia: () => this.repositories.impressao.termoCiencia(this.atendimentoId),
            }

            switch (item) {

                case 'etiqueta': {

                    this.utils.etiqueta.print({
                        ...this.form.recepcao.find(i => i.value === 'etiqueta').data
                    })

                    break
                }
                case 'senha': {

                    this.utils.senha.print({
                        ...this.form.recepcao.find(i => i.value === 'senha').data,
                        infraestrutura: this.lotacao.infraestrutura.nome,
                        setor: this.centroCusto.setor.nome,
                        cliente: this.cliente.nome,
                    })

                    break
                }
                default: {

                    this.openFile(items[item])

                    break
                }
            }
        },
        downloadTriagem(item) {

            const items = {
                raat: () => this.repositories.impressao.raat(this.atendimentoId),
                cat: () => this.repositories.impressao.cat(this.atendimentoId),
                guiaEncaminhamento: () => this.repositories.impressao.atendimentoTriagem.guiaEncaminhamento(this.atendimentoId),
            }

            switch (item) {

                case 'etiqueta': {

                    this.utils.etiqueta.print({
                        ...this.form.triagem.find(i => i.value === 'etiqueta').data
                    })

                    break
                }
                default: {

                    this.openFile(items[item])

                    break
                }
            }
        },
        downloadMedicoEnfermagem(item) {

            const items = {
                atestadoAcompanhante: () => this.repositories.impressao.atendimentoMedico
                    .atestadoAcompanhante(this.atendimentoId),
                atestado: () => this.repositories.impressao.atendimentoMedico
                    .atestado(this.atendimentoId),
                declaracaoAcompanhante: () => this.repositories.impressao.atendimentoMedico
                    .declaracaoComparecimentoAcompanhante(this.atendimentoId),
                declaracaoPaciente: () => this.repositories.impressao.atendimentoMedico
                    .declaracaoComparecimentoPaciente(this.atendimentoId),
                encaminhamentoHospitalar: () => this.repositories.impressao.atendimentoMedico
                    .encaminhamentoHospitalar(this.atendimentoId),
                examesImagem: () => this.repositories.impressao.atendimentoMedico
                    .solicitacaoExamesImagem(this.atendimentoId),
                examesLaboratorial: () => this.repositories.impressao.atendimentoMedico
                    .solicitacaoExamesLaboratoriais(this.atendimentoId),
                guiaEncaminhamento: () => this.repositories.impressao.atendimentoMedico
                    .guiaEncaminhamento(this.atendimentoId),
                orientacoesPaciente: () => this.repositories.impressao.atendimentoMedico
                    .orientacoes(this.atendimentoId),
                receitaMedicaComum: () => this.repositories.impressao.atendimentoMedico
                    .receita(this.atendimentoId),
                receitaMedicaEspecial: () => this.repositories.impressao.atendimentoMedico
                    .receitaEspecial(this.atendimentoId),
                servicoEnfermagem: () => this.repositories.impressao.atendimentoMedico
                    .servicoEnfermagem(this.atendimentoId),
                prescricaoInterna: () => this.repositories.impressao.atendimentoMedico
                    .prescricaoInterna(this.atendimentoId, {
                        atendimentos: this.model.atendimentosPrescricaoInterna,
                    }),
            }

            this.openFile(items[item])
        },
        downloadFaa(item) {

            const items = {
                simplificada: () => this.repositories.impressao.faa.simplificada(this.atendimentoId),
                completa: () => this.repositories.impressao.faa.completa(this.atendimentoId),
                eletronica: () => this.repositories.impressao.faa.eletronica(this.atendimentoId),
                eletronicaObservacao: () => this.repositories.impressao.faa.eletronica(this.atendimentoId, {
                    atendimentos: this.model.atendimentosFaaEletronicaObservacao,
                }),
            }

            this.openFile(items[item])
        },
        openFile(repository) {

            this.setLoading()

            repository()
                .then(response => {

                    const content = new Blob([response.data], { type: response.headers['content-type'] })
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {

            this.form.recepcao = []
            this.form.triagem = []
            this.form.medicoEnfermagem = []
            this.form.faa = []

            this.model.recepcao = []
            this.model.triagem = []
            this.model.medicoEnfermagem = []
            this.model.faa = []

            this.model.selectAllRecepcao = false
            this.model.selectAllTriagem = false
            this.model.selectAllMedicoEnfermagem = false

            if (typeof this.callbackOnClose === 'function') {

                this.callbackOnClose()
            }
        },
        executeActionPrescricaoInterna(){

            if (!this.model.medicoEnfermagem.includes('prescricaoInterna')) {

                this.model.atendimentosPrescricaoInterna = []
            }

            this.model.medicoEnfermagem.forEach(impressao => {

                switch (impressao) {

                    case 'prescricaoInterna': {

                        this.$refs.ModalImpressaoPrescricaoInterna.open()

                        break;
                    }
                }
            })
        },
        executeActionFaa() {

            if (!this.model.faa.includes('eletronica')) {

                this.model.lotacaoFaturamentoExameLaboratorialId = null
            }

            if (!this.model.faa.includes('eletronicaObservacao')) {

                this.model.atendimentosFaaEletronicaObservacao = []
            }

            this.model.faa.forEach(impressao => {

                switch (impressao) {

                    case 'eletronica': {

                        if (this.additionals.faturarEnfermagem
                            && this.additionals.hasExamesLaboratoriaisPendente
                            && this.model.lotacaoFaturamentoExameLaboratorialId === null
                        ) {

                            if (this.additionals.usuariosFaturamentoExameLaboratorial.length === 0) {

                                this.showWarningNotification(`É necessário cadastrar um profissional na
                                    parametrização para faturar os procedimentos laboratoriais.`)

                                this.uncheckFaaEletronica()
                            }
                            else if (this.additionals.usuariosFaturamentoExameLaboratorial.length === 1
                                && this.additionals.usuariosFaturamentoExameLaboratorial[0].lotacoes.length === 1
                            ) {

                                this.model.lotacaoFaturamentoExameLaboratorialId = this.additionals
                                    .usuariosFaturamentoExameLaboratorial[0].lotacoes[0].id
                            }
                            else {

                                this.$refs.ModalUsuarioFaturamentoExameLaboratorial.open()
                            }
                        }

                        break;
                    }
                    case 'eletronicaObservacao': {

                        if (this.model.atendimentosFaaEletronicaObservacao.length === 0) {

                            this.$refs.ModalImpressaoObservacao.open()
                        }

                        break;
                    }
                }
            })
        },
    },
    props: {
        plantaoId: { type: Number, default: null },
        fromObservacao: { type: Boolean, default: false },
    },
    watch: {
        'model.selectAllRecepcao': function (selectAll) {

            this.model.recepcao = selectAll
                ? this.form.recepcao.filter(i => !i.disabled).map(i => i.value)
                : []
        },
        'model.selectAllTriagem': function (selectAll) {

            this.model.triagem = selectAll
                ? this.form.triagem.filter(i => !i.disabled).map(i => i.value)
                : []
        },
        'model.selectAllMedicoEnfermagem': function (selectAll) {

            this.model.medicoEnfermagem = selectAll
                ? this.form.medicoEnfermagem.filter(i => !i.disabled).map(i => i.value)
                : []
        },
        'model.faa': function () {

            this.executeActionFaa()
        },
        'model.medicoEnfermagem': function (novo) {

            novo.filter(f => {

                if(f === 'prescricaoInterna'){

                   this.executeActionPrescricaoInterna()
                }
            })
        },
    }
}
</script>